import { DedupeComponent } from '../../dedupe/dedupe.component';
import { LeadsBoardComponent } from './leads-board.component';
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BoardView, LeadsBoardStateService } from './leads-board-state.service';

/** Keeps the lead table/board mounted while a routed lead page opens in its place. */
@Component({
  selector: 'app-leads-workspace',
  templateUrl: './leads-workspace.component.html',
  host: { class: 'workspace-master-detail-page' },
  providers: [LeadsBoardStateService],
})
export class LeadsWorkspaceComponent {
  @ViewChild(LeadsBoardComponent) collection?: LeadsBoardComponent;
  reviewClosed(component: unknown): void {
    if (component instanceof DedupeComponent && component.needsRefresh) this.collection?.onTransferChanged();
  }

  /**
   * Whether a routed detail page is open in place of the collection.
   *
   * Read from the route, not set from the outlet's (activate) event. That
   * event fires DURING change detection, after this binding has already been
   * checked, so the new value arrived too late to render: Angular reported
   * NG0100 and the class that opens the detail pane was never applied. The
   * pane stayed at flex 0 with visibility:hidden - a blank panel showing
   * nothing, with no error on it to say why.
   *
   * The router builds its ActivatedRoute tree before it activates any outlet,
   * so firstChild already answers this by the time the template is checked.
   * None of the children here is an empty path, so a child means a detail.
   */
  get detailOpen(): boolean { return this.route.firstChild !== null; }

  constructor(
    private readonly route: ActivatedRoute,
    state: LeadsBoardStateService,
  ) {
    const view = route.snapshot.data['leadCollectionView'] as BoardView;
    state.view = view;
  }
}
